import {Component, Input} from '@angular/core';
import {NotificationItem} from '../notification.model';

@Component({
    selector: 'app-notification-detail',
    templateUrl: 'notification-detail.component.html',
    styleUrls: ['notification-detail.component.scss']
})
export class NotificationDetailComponent {
    @Input() notificationItem: NotificationItem;
}
